export default __webpack_public_path__ + "static/media/HSimage2.e2eca094.avif";